/**
 * Parses `whitelisted_enquiry_nos_for_latest_estimate_ui` and checks enquiry/order no.
 */
export function parseWhitelistedEnquiryNos(
  raw: unknown,
): string[] {
  if (Array.isArray(raw)) {
    return raw.map((entry) => String(entry).trim()).filter(Boolean);
  }
  if (typeof raw === "string") {
    return raw
      .split(",")
      .map((entry) => entry.trim())
      .filter(Boolean);
  }
  return [];
}

export function isEnquiryWhitelistedForLatestEstimateUi(
  rawWhitelist: unknown,
  orderNo?: string | null,
  orderData?: {
    orderNo?: string;
    orderNumber?: string;
    enquiryNo?: string;
  } | null,
): boolean {
  const whitelist = parseWhitelistedEnquiryNos(rawWhitelist);
  if (whitelist.length === 0) {
    return false;
  }
  const enquiryNo = String(
    orderNo ||
      orderData?.orderNo ||
      orderData?.orderNumber ||
      orderData?.enquiryNo ||
      "",
  )
    .trim()
    .toLowerCase();
  if (!enquiryNo) {
    return false;
  }
  return whitelist.some((entry) => entry.toLowerCase() === enquiryNo);
}
